<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Blacklisted Originators</h5>
        <div class="ibox-tools">
          <el-tooltip class="item" content="Blacklist Originator" placement="left">
            <el-button type="primary" size="small" class="ibox-tool-btn" @click="showCreateDialog=true" plain>
              <i class="fa fa-plus"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <div class="ibox-content ibox-heading">
        Listeners who's messages we'd like to ban from showing on our interaction panels.
      </div>
      <div class="ibox-content blacklist-list-content">
        <el-table :data="blacklistedOriginators" :fit="true" :default-sort="{prop: 'title'}" row-key="id" max-height="400" style="width: 100%" stripe>
          <el-table-column type="index" label="#" width="60" />
          <el-table-column prop="originator" label="Originator"  width="200" class-name="client-link">
            <template slot-scope="scope">
              <el-tooltip class="item" content="Edit" placement="right">
                <a @click="editBlacklistedOriginator(scope.row)">{{scope.row.originator}}</a>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column type="date_created" label="Date Added" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.date_created | moment("Do MMM YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown trigger="hover" placement="bottom" @command="handleAction">
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{action: editBlacklistedOriginator, item: scope.row}">Edit</el-dropdown-item>
                  <el-dropdown-item :command="{action: deleteBlacklistedOriginator, item: scope.row}">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :title="this.isNewBlacklistOriginator ? 'Blacklist Originator' : 'Edit Blacklisted Originator'" :visible.sync="showEditDialog" :close-on-click-modal="false">

      <blacklist-originator-edit v-if="showEditDialog" :originator="selectedBlacklistedOriginator" @cancel="showEditDialog = false" @save="updateBlacklist">
      </blacklist-originator-edit>

      <blacklist-originator-create v-if="showCreateDialog" @cancel="showCreateDialog = false" @save="addBlacklistOriginator">
      </blacklist-originator-create>
    </el-dialog>

    <el-dialog :title="'Blacklist Originator'" :visible.sync="showCreateDialog" :close-on-click-modal="false">
      <blacklist-originator-create v-if="showCreateDialog" @cancel="showCreateDialog = false" @save="addBlacklistOriginator">
      </blacklist-originator-create>
    </el-dialog>
  </div>

</template>

<script>
/* eslint no-param-reassign: "off" */
import SocialIcon from '@/components/common/Icons/SocialIcon';
import BlacklistOriginatorEdit from '@/components/blacklist/BlacklistOriginatorEdit';
import BlacklistOriginatorCreate from '@/components/blacklist/BlacklistOriginatorCreate';

export default {
  name: 'BlacklistOriginatorList',
  components: { SocialIcon, BlacklistOriginatorEdit, BlacklistOriginatorCreate },
  data: () => ({
    showEditDialog: false,
    showCreateDialog: false,
    isNewBlacklistOriginator: false,
  }),
  props: {
    blacklistedOriginators: {
      type: Array,
      required: true,
    },
  },
  methods: {
    blacklistOriginator() {
      this.showCreateDialog = true;
    },
    addBlacklistOriginator(originator) {
      this.$store.dispatch('blacklist/addBlacklistOriginator', originator);
      this.showCreateDialog = false;
    },
    updateBlacklist(originator) {
      const action =
        'id' in originator
          ? 'blacklist/updateBlacklistOriginator'
          : 'blacklist/addBlacklistOriginator';
      this.$store.dispatch(action, originator);
      this.showEditDialog = false;
    },
    editBlacklistedOriginator(originator) {
      this.showEditDialog = !this.showEditDialog;
      const newOriginator = {
        originator: '',
        company: this.$store.state.user.me.use_as_company,
      };
      this.selectedBlacklistedOriginator = originator || newOriginator;
    },
    deleteBlacklistedOriginator(originator) {
      const confirmationMessage = `Are you sure you want to allow messages from ${originator.originator}?`;
      this.$confirm(confirmationMessage, {
        confirmButtonText: "Yes, I'm sure",
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('blacklist/deleteBlacklistedOriginator', originator.id);
      });
    },
    handleAction(command) {
      /**
       * Executes the action by passing the item as parameter.
       *
       * @param {command}: object with actions and item properties
       */
      command.action(command.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.blacklist-list-content {
  padding: 8px;
}

.ibox-tool-btn {
  margin-top: -10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// BlacklistOriginatorList.vue?01f27c01